// @flow
import * as React from 'react';
import PropTypes from 'prop-types';

import NavBar from '../common/nav-bar/NavBarComponent';
import TileList from './tile-list/TileListComponent';
import ProductHeader from '../products/header/ProductHeaderComponent';

import accessoriesNavItems from '../data/AccessoriesNavItems';
import productsMessages from '../../data/products';
import accessoriesMessages from '../../data/accessories';

import { getProductTypeIntlPluralKey } from '../services/product-type/ProductTypeService';

import { canOrderAccessories } from '../services/user-permission/UserPermissionService';
import AccessoriesRestrictedView from './AccessoriesRestrictedViewComponent';

import './AccessoriesPage.scss';

type Props = {
  config: {
    permissions: Array<string>,
    contacts: Object,
  },
  actions: {
    getAccessories: Function,
    dismissSideNavAnnouncement: Function,
  },
  location: {
    pathname: string,
  },
  accessories: Object,
};

class AccessoriesPageComponent extends React.Component<Props> {
  constructor() {
    super();
    this.state = {
      activeTab: null,
    };
  }

  navBarItems = () =>
    accessoriesNavItems.map((navItem) => ({
      value: navItem.route,
      label: this.context.intl.formatMessage(getProductTypeIntlPluralKey(navItem.id)),
    }));

  UNSAFE_componentWillMount(): void {
    const { actions, config, location } = this.props;

    actions.getAccessories(location.pathname.split('/').pop(), 0);

    if (canOrderAccessories(config.permissions)) {
      actions.dismissSideNavAnnouncement();
    }
  }

  componentWillReceiveProps(newProps: any) {
    const activeTab = newProps.location.pathname.split('/').pop();
    if (this.state.activeTab !== activeTab) {
      if (!this.state.activeTab) {
        this.setState({ activeTab });
      } else {
        this.setState({ activeTab }, () => {
          this.props.actions.getAccessories(activeTab, 0);
        });
      }
    }
  }

  render() {
    const { config, actions, accessories } = this.props;
    const accessoryType = this.state.activeTab || this.props.location.pathname.split('/').pop();

    if (!canOrderAccessories(config.permissions) && !accessories.isLoading) {
      return <AccessoriesRestrictedView actions={actions} config={config} />;
    }

    return (
      <div className="accessories-page-component">
        <ProductHeader isVisible mode="default">
          <NavBar
            items={this.navBarItems()}
            activeRoute={accessoryType}
            page="accessories"
            message={this.context.intl.formatMessage(productsMessages.selectProductDropdownLabel)}
          />
        </ProductHeader>
        <div className="accessories-page__tile-list wrapper">
          <TileList
            isLoading={accessories.isLoading}
            items={accessories.items}
            loadMore={() => {
              this.props.actions.getAccessories(accessoryType, accessories.items.length);
            }}
            hasMore={accessories.items.length < accessories.total}
            hoverButtonText={this.context.intl.formatMessage(accessoriesMessages.accessoriesShopNowButtonText)}
          />
        </div>
      </div>
    );
  }
}

AccessoriesPageComponent.displayName = 'AccessoriesPage';

AccessoriesPageComponent.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default AccessoriesPageComponent;
